<script setup>
import { ref, computed } from 'vue';
import Input from 'dashboard/components-next/input/Input.vue';
import FormFooter from './FormFooter.vue';

const emit = defineEmits(['sendMessage', 'cancel']);

const url = ref('');
const title = ref('');
const description = ref('');
const text = ref('');
const imgUrl = ref('');

// Evolution's /send/link rejects the request server-side without `text`
// ("message body is required") even though it's not URL/title/description.
const isValid = computed(() => !!url.value.trim() && !!text.value.trim());

const submit = () => {
  if (!isValid.value) return;

  emit('sendMessage', {
    message: '',
    contentType: 'link',
    contentAttributes: {
      data: {
        url: url.value.trim(),
        title: title.value.trim() || undefined,
        description: description.value.trim() || undefined,
        text: text.value.trim(),
        imgUrl: imgUrl.value.trim() || undefined,
      },
    },
  });
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <Input
      v-model="url"
      :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.LINK.URL')"
    />
    <Input
      v-model="title"
      :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.LINK.TITLE')"
    />
    <Input
      v-model="description"
      :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.LINK.DESCRIPTION')"
    />
    <Input
      v-model="text"
      :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.LINK.TEXT')"
    />
    <Input
      v-model="imgUrl"
      :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.LINK.IMG_URL')"
    />
    <FormFooter
      :disabled="!isValid"
      @cancel="$emit('cancel')"
      @submit="submit"
    />
  </div>
</template>
